import React from "react";

export const Logo: React.FC = () => <img alt="" className="logo" src="julies-angels.jpg" />;
